var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderImg',{attrs:{"content":_vm.pipelineHeaderImg}}),_c('MainPipeline',{class:_vm.sections.pipeline})],1)}
var staticRenderFns = []

export { render, staticRenderFns }